import api from './api';

export const usersApi = {
  getUser: async (nickname) => {
    const response = await api.get(`/users/${encodeURIComponent(nickname)}`, {
      suppressGlobalError: true,
    });
    return response.data;
  },
  getUserById: async (userId, { signal } = {}) => {
    const response = await api.get(`/users/by-id/${userId}`, {
      suppressGlobalError: true,
      signal,
    });
    return response.data;
  },
  getUserReviews: async (nickname) => {
    const response = await api.get(`/users/${encodeURIComponent(nickname)}/reviews`);
    return response.data;
  },

  getUserLists: async (nickname) => {
    const response = await api.get(`/users/${encodeURIComponent(nickname)}/lists`);
    return response.data;
  },

  getUserComments: async (nickname) => {
    const response = await api.get(`/users/${encodeURIComponent(nickname)}/comments`);
    return response.data;
  },

  getUserBookmarks: async (nickname) => {
    const response = await api.get(`/users/${encodeURIComponent(nickname)}/saved`);
    return response.data;
  },

  getFollowStatus: async (userId) => {
    const response = await api.getAuth(`/users/${userId}/follow`, {
      suppressGlobalError: true,
    });
    return response.data;
  },

  getFollowers: async (nickname) => {
    const response = await api.getAuth(`/users/${encodeURIComponent(nickname)}/followers`);
    return response.data;
  },

  getFollowing: async (nickname) => {
    const response = await api.getAuth(`/users/${encodeURIComponent(nickname)}/following`);
    return response.data;
  },

  followUser: async (userId) => {
    const response = await api.postAuth(`/users/${userId}/follow`, {});
    return response.data;
  },

  unfollowUser: async (userId) => {
    const response = await api.deleteAuth(`/users/${userId}/follow`);
    return response.data;
  },
};
